import { DEFAULT_CHIEF_PATH } from '@/constants/axios'
import { adaptResponseForClient } from '@/helpers/adaptResponseForClient'
import type { SubscriptionPayment, SubscriptionPlan, SubscriptionStatus } from '@/types/subscription'
import axios from 'axios'

type ApiResponse<T> = {
  data: T | { data: T }
}

const resourceData = <T>(response: ApiResponse<T>): T => {
  const data = adaptResponseForClient(response.data) as T | { data: T }

  return typeof data === 'object' && data !== null && 'data' in data
    ? data.data
    : data
}

export const getSubscriptionStatusApiCall = async (): Promise<SubscriptionStatus> => {
  const { data } = await axios.get<ApiResponse<SubscriptionStatus>>(
    `${DEFAULT_CHIEF_PATH}/subscription`,
  )

  return resourceData(data)
}

export const getSubscriptionPlansApiCall = async (): Promise<SubscriptionPlan[]> => {
  const { data } = await axios.get<ApiResponse<SubscriptionPlan[]>>(
    `${DEFAULT_CHIEF_PATH}/subscription/plans`,
  )

  return resourceData(data)
}

export const createSubscriptionPaymentApiCall = async (
  plan: string,
): Promise<SubscriptionPayment> => {
  const { data } = await axios.post<ApiResponse<SubscriptionPayment>>(
    `${DEFAULT_CHIEF_PATH}/subscription/payment`,
    { plan },
  )

  return resourceData(data)
}
